import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormikContext, useFormik } from "formik";
import { BsSearch } from "react-icons/bs";
import SearchStyled, {
  SearchIcon,
  SearchButton,
  SearchInput,
} from "./SearchControl.Style";
import InputControl from "../InputControl";

const SearchControl = (props) => {
  const { name, icon: Icon, onSearchButtonClick } = props;
  const formik = useFormik({
    initialValues: {
      [name]: "",
    },
  });

  const { values } = formik;

  const searchButtonClickHandle = useCallback(() => {
    if (onSearchButtonClick) {
      onSearchButtonClick(values[name]);
    }
  }, [name, onSearchButtonClick, values]);

  return (
    <FormikContext.Provider value={formik}>
      <SearchStyled>
        <SearchInput {...props} as={InputControl} />
        <SearchButton onClick={searchButtonClickHandle}>
          <SearchIcon as={Icon} />
        </SearchButton>
      </SearchStyled>
    </FormikContext.Provider>
  );
};

SearchControl.defaultProps = {
  icon: BsSearch,
  onSearchButtonClick: null,
};

SearchControl.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  onSearchButtonClick: PropTypes.func,
};

export default SearchControl;
